import React from 'react';
import SeoWrapper from '../components/SeoWrapper';
import Projects from '../components/Projects';
import content from '../data/content.json';

const ProjectsPage = ({ language }) => {
  return (
    <>
      <SeoWrapper
        title={language === 'pl' ? "Projekty" : "Projects"}
        description={language === 'pl' ? content.projects.description_pl : content.projects.description_en}
        url="/projekty"
      />
      <div className="pt-20">
        <Projects projects={content.projects} language={language} />
      </div>
    </>
  );
};

export default ProjectsPage;
